import { editWorkspaceName } from "api/services/workspace-service";
import useWorkspaceApiCall from "hooks/useWorkspaceApiCall";

export const useEditWorkspaceName = () => {
    const { callAPI, loading } = useWorkspaceApiCall(editWorkspaceName, 'editWorkspaceName.success', 'editWorkspaceName.error');

    return { editWorkspaceName: callAPI, editingWorkspaceName: loading };
}